import { useState } from 'react';

interface LeaseAdvisorContactDataProps {
  name: string;
  description: string;
  email: string;
  phone: string;
  avatarUrl: string;
  className?: string;
}

export function LeaseAdvisorContactData({
  name,
  description,
  email,
  phone,
  avatarUrl,
  className,
}: LeaseAdvisorContactDataProps) {
  const [hasError, setHasError] = useState(false);
  return (
    <div
      className={`relative flex w-full flex-col items-center justify-between gap-md rounded-DEFAULT bg-light-gray pt-sm  md:flex-row ${
        className ?? ''
      }`}
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          top: 0,
          width: '100%',
          height: '1px',
          backgroundRepeat: 'repeat-x',
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='1'><rect width='5' height='1' fill='%23d1d5db'/></svg>\")",
        }}
      />
      <div className="flex flex-col items-center gap-xs md:flex-row ">
        {!hasError && (
          <img
            src={avatarUrl}
            alt={name}
            className="h-2xl w-2xl rounded-full border-4 border-solid border-dark-green bg-green object-cover"
            onError={() => setHasError(true)}
          />
        )}
        {hasError && (
          <div className="bg-gray-200 text-2xl font-bold flex h-2xl w-2xl select-none items-center justify-center rounded-full border-4 border-solid border-dark-green font-semibold text-navy">
            {(() => {
              if (!name) return '';
              const parts = name.trim().split(' ');
              // `split` on a non-empty string always yields at least one
              // element, and the trailing index is in range by construction —
              // the element reads already assumed both.
              if (parts.length === 1) {
                return parts[0]![0]?.toUpperCase() ?? '';
              }
              return `${parts[0]![0]?.toUpperCase() ?? ''}${parts[parts.length - 1]![0]?.toUpperCase() ?? ''}`;
            })()}
          </div>
        )}
        <div className="flex flex-col  items-center md:items-start">
          <span className="text-p3 font-semibold text-navy">{name}</span>
          <span className="text-p1 text-navy">{description}</span>
        </div>
      </div>
      <div className="text-p3 flex flex-col-reverse items-center gap-2xs font-semibold text-navy md:flex-col md:items-end">
        {email && (
          <a
            href={`mailto:${email}`}
            className="text-navy transition-colors hover:text-dark-navy"
            aria-label={`Email ${name}`}
          >
            {email}
          </a>
        )}
        {phone && (
          <a
            href={`tel:${phone.replace(/\D/g, '')}`}
            className="text-navy transition-colors hover:text-dark-navy"
            aria-label={`Call ${name}`}
          >
            {phone.replace(/\D/g, '').length === 10
              ? `(${phone.replace(/\D/g, '').slice(0, 3)}) ${phone.replace(/\D/g, '').slice(3, 6)}-${phone
                  .replace(/\D/g, '')
                  .slice(6)}`
              : phone}
          </a>
        )}
      </div>
    </div>
  );
}
